export default [
    {
        path: '/painel-gerencial',
        name: 'painelGerencial',
        component: () => import('@/modules/painelGerencial/views/PainelGerencialView.vue'),
        meta: {
            requiresAuth: true,
            temFilhas: true,
            permissoes: ['read:painelgerencial'],
            isRotaOrigem: true,
        },
        redirect: { name: 'painelGerencialFinanceiro' },
        children: [
            {
                path: '/painel-gerencial/financeiro',
                name: 'painelGerencialFinanceiro',
                component: () => import('@/modules/painelGerencial/components/abas/FinanceiroAba.vue'),
            },
            {
                path: '/painel-gerencial/bolsas',
                name: 'painelGerencialBolsas',
                component: () => import('@/modules/painelGerencial/components/abas/BolsasAba.vue'),
            },
            {
                path: '/painel-gerencial/prestadores',
                name: 'painelGerencialPrestadores',
                component: () => import('@/modules/painelGerencial/components/abas/PrestadoresAba.vue'),
            },
            {
                path: '/painel-gerencial/membros',
                name: 'painelGerencialMembros',
                component: () => import('@/modules/painelGerencial/components/abas/MembrosAba.vue'),
            },
        ],
    },
];
